function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 576 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M515.548,204.032c5.144,20.432 1.858,53.346 -9.782,78.69l-7.64,48.417l-23.51,71.928c-2.501,7.651 -9.456,12.803 -17.283,12.803l-2.423,-0c-12.399,-0 -21.184,-12.485 -17.34,-24.645l15.265,-65.56c-0,-0 -38.78,-71.879 -28.142,-105.192",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "12.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.314,190.93l14.362,76.55l-23.796,141.923c-1.164,9.228 -8.694,16.191 -17.713,16.38l-2.882,0.061c-12.503,0.263 -21.558,-12.174 -17.749,-24.461c7.75,-25 9.214,-65.409 -2.264,-92.993c-13.109,-31.502 -7.065,-46.522 -7.065,-46.522",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "12.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.385,309.511c0,0 113.495,12.303 144.289,-13.521",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "12.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.717,308.389c-0,0 -20.342,-34.398 -11.625,-86.761c16.13,-96.892 -60.49,-107.398 -60.49,-107.398l-3.188,-1.23l-230.738,-5.809l-87.25,9.508",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "12.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.26,285.923l29.584,35.989l-0.609,78.319c-0,8.638 -6.788,15.64 -15.162,15.64l-15.772,-0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "12.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.078,100.922c18.679,23.813 37.359,23.813 37.359,23.813",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "12.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.023,86.152c13.299,26.676 -16.309,40.366 -16.309,40.366c-0,-0 -25.492,-35.449 -51.277,-1.783l-19.338,23.452c-0,0 -19.806,32.566 -33.681,51.248c-3.86,5.198 3.1,22.749 6.432,28.321c6.2,10.368 50.219,16.761 91.225,1.993c0,-0 34.204,3.064 40.637,66.247c1.223,12.016 25.685,28.296 45.82,25.623",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "12.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.008,187.579c44.623,14.565 46.867,-23.061 46.867,-23.061l-0,-2.428c-21.709,-25.894 -41.81,-7.283 -41.81,-7.283",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "12.55px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCow);
export default __webpack_public_path__ + "static/media/cow.cfab2ba745b2781a113228e631eb9b9a.svg";
export { ForwardRef as ReactComponent };